// テナントコンテキスト Resolver
// URL の tenantId に対応するテナントを TenantsStore に選択状態として設定する
import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type ResolveFn,
  type UrlTree,
} from '@angular/router';

import { TenantsStore } from '../tenants.store';

/**
 * tenantContextResolver
 * tenantGuard が認可（tenantId 存在確認・テナント一覧チェック）を完了した後に実行される。
 * tenantsStore.selectTenant(tenantId) を呼び出して選択テナントを確定させる。
 */
export const tenantContextResolver: ResolveFn<boolean | UrlTree> = (
  route: ActivatedRouteSnapshot,
) => {
  const tenantsStore = inject(TenantsStore);
  const router = inject(Router);

  const tenantId = route.params['tenantId'] as string | undefined;

  if (!tenantId) {
    // tenantGuard が先に tenantId チェックを行うため通常は到達しないが防御的に実装
    return router.createUrlTree(['/tenants']);
  }

  tenantsStore.selectTenant(tenantId);
  return true;
};
